<template>
    <div class="createRole">
        <v-dialog v-model="dialog" max-width="900px" persistent scrollable>
            <v-card class="rounded-lg">
                <v-card-title class="px-6 py-4 border-b">
                    <span class="text-h6 font-weight-bold">{{formTitle}}</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                
                <v-card-text class="px-6 py-4" style="max-height: 80vh">
                    <form @submit.prevent="createData" id="role-form" novalidate>
                        <div class="subtitle-2 font-weight-bold mb-3 text-uppercase grey--text text--darken-1">1. Thông tin chung</div>
                        <v-row class="mb-2">
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field
                                    v-model="form.RoleName"
                                    label="Tên phân quyền *"
                                    outlined dense
                                    required
                                    hide-details="auto"
                                    class="mb-4"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field
                                    v-model="form.Alias"
                                    label="Alias *"
                                    outlined dense
                                    required
                                    hide-details="auto"
                                    class="mb-4"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" class="py-0">
                                <v-text-field
                                    v-model="form.Description"
                                    label="Mô tả chi tiết"
                                    outlined dense
                                    hide-details="auto"
                                    class="mb-4"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" class="py-0">
                                <v-autocomplete
                                    :items="formData.departments"
                                    v-model="form.Managers" 
                                    small-chips deletable-chips
                                    label="Chi nhánh quản lý" multiple
                                    item-value="code"
                                    item-text="name"
                                    outlined dense
                                    hide-details="auto"
                                    class="mb-4"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-divider class="mb-4"></v-divider>
                        
                        <div class="d-flex align-center mb-3">
                            <div class="subtitle-2 font-weight-bold text-uppercase grey--text text--darken-1">2. Danh sách quyền truy cập</div>
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="permissionSearch"
                                append-icon="mdi-magnify"
                                label="Tìm kiếm nhanh..."
                                dense outlined hide-details
                                style="max-width: 250px"
                            ></v-text-field>
                        </div>
                        
                        <v-card outlined class="rounded-lg">
                            <v-data-table
                                show-select
                                hide-default-footer
                                :items-per-page="-1"
                                item-key="code"
                                v-model="form.Permissions"
                                :headers="permissionHeaders"
                                :items="permissions"
                                :search="permissionSearch"
                                class="elevation-0"
                                height="400px"
                                fixed-header
                            >
                                <template v-slot:[`item.groupSlug`]="{ item }">
                                    <v-chip small color="blue lighten-5" text-color="blue darken-3" class="font-weight-medium">
                                        {{ item.groupSlug }}
                                    </v-chip>
                                </template>
                                <template v-slot:[`item.code`]="{ item }">
                                    <span class="font-weight-bold grey--text text--darken-2">{{ item.code }}</span>
                                </template>
                                <template v-slot:[`item.slug`]="{ item }">
                                    <span class="text-caption grey--text">{{ item.slug }}</span>
                                </template>
                            </v-data-table>
                        </v-card>
                    </form>
                </v-card-text>
                
                <v-divider></v-divider>
                
                <v-card-actions class="px-6 py-4">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey darken-1"
                        text
                        class="text-none px-4 rounded-md"
                        @click="close"
                    >
                        Hủy bỏ
                    </v-btn>
                    <v-btn
                        color="teal darken-4"
                        class="text-none px-6 rounded-md font-weight-bold ml-2 white--text"
                        elevation="2"
                        type="submit"
                        form="role-form"
                    >
                        <v-icon left small>mdi-content-save</v-icon>
                        Lưu thông tin
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common'

export default {
    name: "RoleCreateDialog",
    computed: {
        formTitle(){
            return this.isUpdate ? "Cập nhật phân quyền" : "Tạo mới phân quyền";
        },
        selectedCode () {
            return this.form.Permissions.map(obj => obj ? obj.code : null).filter(c => c);
        }
    },
    watch: {
        dialog (val) {
            if(val) {
                // If it's pure create, empty selection.
                // Fetch permissions will sort but since form.Permissions is empty it just sorts by slug / name.
                this.fetchPermissions();
            } else {
                this.close();
            }
        }
    },
    data () {
        return {
            DEPARTMENT_URL: "departments",
            permissionData:[],
            item: undefined,
            isUpdate: false,
            dialog: false,
            form: {
                RoleName:"",
                Alias: "",
                Description: "",
                Permissions: [],
                Managers:[],
            },
            defaultForm: {
                RoleName:"",
                Alias: "",
                Description: "",
                Managers:[],
                Permissions: []
            },
            formData: {
                Employees: [],
                departments:[],
                permissions: []
            },
            permissionSearch: "",
            permissionHeaders: [
                {text: "Nhóm quyền (Slug)", value:"groupSlug", width: '200px'},
                {text: "Mã", value:"code", width: '150px'},
                {text: "Tên quyền", value:"name"},
                {text: "Slug", value:"slug"},
            ],
            permissions: [],
        }
    },
    methods: {
        sortPermissionsOnce() {
            if (!this.permissions || this.permissions.length === 0) return;
            
            const selectedCodes = new Set(this.form.Permissions.map(p => p.code));
            
            this.permissions.sort((a, b) => {
                const aSelected = selectedCodes.has(a.code);
                const bSelected = selectedCodes.has(b.code);
                
                // Checked items visually go to top
                if (aSelected && !bSelected) return -1;
                if (!aSelected && bSelected) return 1;
                
                // Alphabetical sort by group slug, then name
                const slugA = a.groupSlug || '';
                const slugB = b.groupSlug || '';
                if (slugA !== slugB) {
                    return slugA.localeCompare(slugB);
                }
                
                return (a.name || '').localeCompare(b.name || '');
            });
            
            // Re-assign to ensure reactivity updates the view
            this.permissions = [...this.permissions];
        },
        close () {
            this.dialog = false;
            this.isUpdate = false;
            this.permissionSearch = "";
            this.form = Object.assign({}, this.defaultForm);
            // Don't wipe permissions, just uncheck them and re-sort visually to default.
            this.sortPermissionsOnce();
        },

        createData () {
            // Set payload format correctly back to array of strings
            const payload = Object.assign({}, this.form);
            payload.Permissions = this.selectedCode;
            
            if(!this.isUpdate)
                http.post('roles', payload)
                .then(res => {
                    this.$parent.fetchData();
                    this.dialog=false;
                })
                .catch((err)=> {
                    console.log("err", err.response);
                })
            else {
                http.put('roles/' + this.item.code, payload).then(res => {
                    this.$parent.fetchData();
                    this.dialog = false;
                }).catch( (err) => {
                    console.log(err.response ? err.response.status : err);
                })
            }
        },

        fetchUpdate (code){
            http.get("roles/" + code).then(res => {
                let data = res.data;
                this.form.RoleName = data.role.roleName;
                this.form.Alias = data.role.alias;
                this.form.Permissions = data.permissions || [];
                this.form.Description = data.role.description;
                // Sort permissions with fetched selections
                this.sortPermissionsOnce();
            }).catch(err => {
                console.log(err);
            });
        },
                
        fetchDepartment() {
            return http.get(this.DEPARTMENT_URL + "?dropDown=1")
            .then(res => {
                this.formData.departments = res.data;
            })
            .catch(err => {
                console.log(err);
            })
        },

        fetchPermissions () {
            return http.get("permissions").then((res) => {
                this.permissions = res.data.items || [];
                // Sort array correctly
                this.sortPermissionsOnce();
            });
        }
    },
    mounted() {
        this.fetchPermissions();
        this.fetchDepartment();
    }
}
</script>

<style scoped>
.border-b {
    border-bottom: 1px solid #e0e0e0 !important;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-weight: 600;
    font-size: 13px;
    background-color: #f8f9fa;
    white-space: nowrap;
}
</style>